export function sessionRouteId(sessionOrId) {
  if (!sessionOrId) return null
  if (typeof sessionOrId === 'object') {
    return sessionOrId.public_id || String(sessionOrId.id)
  }
  return String(sessionOrId)
}

export function rememberActiveSession(session, userId) {
  const routeId = sessionRouteId(session)
  if (!routeId) return
  if (userId) {
    localStorage.setItem(`aria_last_session:user:${userId}`, routeId)
  } else {
    localStorage.setItem('aria_last_session:anon', routeId)
  }
}

export function storedSessionRouteId(userId) {
  if (userId) {
    return localStorage.getItem(`aria_last_session:user:${userId}`)
  }
  return localStorage.getItem('aria_last_session:anon')
}
